import { ScrollLockContext } from 'contexts/ScrollLockContext'
import React, { useContext, useEffect } from 'react'
import styled from 'styled-components'

/**
 * モーダル共通
 */
const Modal: React.FC<ModalProps> = (props) => {
  const [, setScrollLock] = useContext(ScrollLockContext)

  useEffect(() => {
    if (props.scrollLock) {
      setScrollLock(props.on)
    }
  }, [props.on, props.scrollLock])

  return (
    <React.Fragment>
      {props.on && (
        <React.Fragment>
          {props.greyBack && props.greyBackClose && (
            <GreyBack onClick={props.closeFunction} />
          )}
          {props.greyBack && !props.greyBackClose && <GreyBack />}
          {props.type === 'top' && (
            <ModalAreaTopFixed>
              <ModalContentWrapper cursorPenetrate={props.cursorPenetrate}>
                {props.children}
              </ModalContentWrapper>
            </ModalAreaTopFixed>
          )}
          {props.type === 'center' && (
            <ModalAreaCenterFixed>
              <ModalContentWrapper cursorPenetrate={props.cursorPenetrate}>
                {props.children}
              </ModalContentWrapper>
            </ModalAreaCenterFixed>
          )}
          {props.type === 'manual' && (props.manualTop || props.manualBottom) && (
            <ModalAreaManualFixed
              manualTop={props.manualTop}
              manualBottom={props.manualBottom}
            >
              <ModalContentWrapper cursorPenetrate={props.cursorPenetrate}>
                {props.children}
              </ModalContentWrapper>
            </ModalAreaManualFixed>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export type ModalProps = {
  on: boolean
  scrollLock?: boolean
  greyBack?: boolean
  // モーダルの位置のタイプ。
  // top(最上部), center(上下左右中央), manual(左右中央&上下は上からor下からの位置指定)
  type: 'top' | 'center' | 'manual'
  manualTop?: string
  manualBottom?: string
  cursorPenetrate?: boolean
  children: React.ReactNode
  closeFunction?: () => void
  greyBackClose?: boolean
}
const GreyBack = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  display: flex;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.32);
`

const ModalAreaTopFixed = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 100;
  pointer-events: none;
`

const ModalAreaCenterFixed = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 100;
  transform: translate(-50%, -50%);
  pointer-events: none;
`

const ModalAreaManualFixed = styled.div<{
  manualTop?: string
  manualBottom?: string
}>`
  position: fixed;
  ${(props): string => (props.manualTop ? `top: ${props.manualTop};` : '')}
  left:0;
  ${(props): string =>
    props.manualBottom ? `bottom: ${props.manualBottom};` : ''}
  z-index: 100;
  display: flex;
  justify-content: center;
  width: 100%;
  pointer-events: none;
`

const ModalContentWrapper = styled.div<{
  cursorPenetrate?: boolean
}>`
  ${(props): string => (props.cursorPenetrate ? '' : 'pointer-events: auto;')}
`

export default React.memo<ModalProps>(Modal)
